module.exports = __webpack_public_path__ + "img/oralTest_sub31.52d249e2.jpg";